import './styles/status_complete.css';
//@ts-ignore
import ScannedSuccessFullyIcon from '../assets/productScannedSuccess.gif';

export default function ScanComplete() {
  return (
        
        <div className="scan_complete_root">
          <div
            className="scan_complete_image_body_container"
            >
            <img src={ScannedSuccessFullyIcon} className="status_complete_icon" />
            <div className='scan_complete_text_container'>
              <p className="scan_complete_main_text">
                Scan Completed !
              </p>
              <p className="scan_complete_secondary_text">
                Remove item & place the next one
              </p>
            </div>
          </div>
        </div>
        
  )
}
